import React from 'react';
import { SkeletonComponent } from '@design-system';

export const EpiFavoriteOrdersSkeleton: React.FC = () => {
    return (
        <div style={{ marginTop: '97px' }}>
            {[...Array(3)].map((_, index) => (
                <SkeletonComponent
                    key={index}
                    count={1}
                    style={{
                        height: '120px',
                        width: 'calc(100% - 32px)',
                        margin: '8px auto',
                        borderRadius: '12px',
                        display: 'block'
                    }}
                />
            ))}
        </div>
    );
};
